export const history = {
    navigate: null,
};